// convert the given number such that it can be display as decimals and corresponding size parameter
export const sizeConversion = (bytes: number, decimal = 2) => {
  const k = 1024;
  const dm = decimal < 0 ? 0 : decimal;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  if (bytes < 0) return "";
  else if (bytes === 0) return "0 Bytes";
  else {
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
};

// remove _ and to lower case
export const text_convert_lower = (value?: string | null) => {
  if (value) {
    return value?.split("_")?.join(" ")?.toLocaleLowerCase();
  }
  return "";
};

// remove _
export const text_convert_1 = (value?: string | null) => {
  if (value) {
    return value?.split("_")?.join(" ");
  }
  return "";
};

// set values to session storage
export const setToSession = (label: string, value: any) =>
  sessionStorage.setItem(label, JSON.stringify(value));

// get values from the session storage
export const getFromSession = (label: string) => {
  const value = sessionStorage.getItem(label);
  if (value) {
    return JSON.parse(value);
  } else return "";
};

// remove from the session storage
export const removeFromSession = (label: string) =>
  sessionStorage.removeItem(label);

// // //

// set values to local storage
export const setToLocal = (label: string, value: any) =>
  localStorage.setItem(label, JSON.stringify(value));

// get values from the local storage
export const getFromLocal = (label: string) => {
  const value = localStorage.getItem(label);
  if (value) {
    return JSON.parse(value);
  } else return "";
};

// remove from the local storage
export const removeFromLocal = (label: string) =>
  localStorage.removeItem(label);

// compair 2 versions
/**
 * less than 0 - v2 is greater
 * greater than 0 - v1 is greater
 * 0 same
 */
export const compareVersions = (version1: string, version2: string) => {
  const v1Components: number[] = version1.split(".").map(Number);
  const v2Components: number[] = version2.split(".").map(Number);

  for (let i = 0; i < Math.max(v1Components.length, v2Components.length); i++) {
    const v1Part: number = v1Components[i] || 0;
    const v2Part: number = v2Components[i] || 0;

    if (v1Part < v2Part) {
      return -1;
    } else if (v1Part > v2Part) {
      return 1;
    }
  }

  return 0;
};

// convert the file upload to data url
export const convertFileToImageData = (
  file: any,
  valueSet: Function,
  setLoader?: Function
) => {
  setLoader && setLoader(true);

  const reader = new FileReader();

  reader.onload = (e: any) => {
    valueSet(e.target.result);
    setLoader && setLoader(false);
  };

  reader.readAsDataURL(file?.value ? new Blob([file?.value]) : file);
};

export const pastDays = (date: any) => {
  if(date){
    const modifiedDateString = date;
    const [dateString, timeString] = modifiedDateString.split(" ");
    const [year, month, day] = dateString.split("-").map(Number);
    const [hour, minute, second] = timeString.split(":").map(Number);
    const modifiedDate = new Date(year, month - 1, day, hour, minute, second); // Month is 0-indexed
    const today = new Date();
    const differenceInMilliseconds = today.getTime() - modifiedDate.getTime();
    const differenceInDays = Math.floor(
      differenceInMilliseconds / (1000 * 60 * 60 * 24)
    );
    return `${differenceInDays}`;
  }
  return ''
};
